import { useEffect, useState } from "react";

export default function PointerLockUI() {
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const handlePointerLockChange = () => {
      setIsLocked(document.pointerLockElement !== null);
    };

    document.addEventListener("pointerlockchange", handlePointerLockChange);

    return () => {
      document.removeEventListener(
        "pointerlockchange",
        handlePointerLockChange
      );
    };
  }, []);

  return (
    <>
      {/* Show this UI only when pointer is locked */}
      {isLocked && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "1px",
            height: "1px",
            backgroundColor: "red",
            borderRadius: "50%",
            zIndex: 1000,
          }}
        ></div>
      )}
    </>
  );
}
